import { render, staticRenderFns } from "./CoverReportPT.vue?vue&type=template&id=281fc776&scoped=true&"
import script from "./CoverReportPT.vue?vue&type=script&lang=js&"
export * from "./CoverReportPT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281fc776",
  null
  
)

export default component.exports